import(/* webpackMode: "eager" */ "/app/apps/lab-app/components/RegisterSCN.tsx")